<div
  class="min-h-screen mx-auto px-4 flex flex-col"
  *ngIf="config"
  [class.max-w-5xl]="config.screenRatio < 1"
  [class.max-w-xl]="config.screenRatio >= 1"
>
  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <div class="flex-none md:my-6 flex flex-col md:w-2/3 md:mx-auto" id="options-container">
    <ng-container *ngFor="let cb of blocks">
      <img [src]="cb.block.image_url" class="block-image cursor-pointer" (click)="select(cb.block.key, cb.block?.value)" alt="">
    </ng-container>
  </div>

  <content-block [slug]="'default-choose-top'" id="default-choose-top-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-choose-top'" id="wbm-choose-top-wrapper" [class.hidden]=" ! boothMode"></content-block>


  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disclaimer-bottom'" id="wbm-disclaimer-bottom-wrapper" [class.hidden]=" ! boothMode"></content-block>

</div>
